import React, { useState, useEffect, useRef } from "react";
import "./Apikey.scss";
import ReactLoading from "react-loading";
import {
  deleteAPIKey,
  getUserAPIKeys,
} from "../../../utils/services/lighthouse";
import { AiOutlineDelete } from "react-icons/ai";
import { useSelector } from "react-redux";
import Dialog from '@mui/material/Dialog';
import { Pagination } from "../../../components";
import { ApikeyDialog } from "../../../dialogs";
import { changeStore } from "../../../store/useStore";

function Apikey() {
  const [APIKeys, setAPIKeys] = useState([]);
  const [itemsPerPage, setitemsPerPage] = useState(10);
  const [currentItems, setCurrentItems] = useState([]);
  const [isGenerateDisabled, setGenerateDisabled] = useState(true);
  const [responseReceived, setResponseReceived] = useState(true);
  const [isKeyDialog, setKeyDialog] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const store = useSelector((store: any) => store);
  const isMobile = store?.otherData?.isMobile || false;

  useEffect(() => {
    let componentMounted = true;
    if (componentMounted) {
      setitemsPerPage(10);
    }
    return () => {
      componentMounted = false;
    };
  }, []);

  
  useEffect(() => {
    let componentMounted = true;
    if (componentMounted) {
      (async () => {
        if (responseReceived) {
          const apiKeys = await getUserAPIKeys();
          apiKeys?.length > 0 && changeStore("setData", { first_api_key: true });
          setAPIKeys(apiKeys);
        }
      })();
    }

    return () => {
      componentMounted = false;
    };
  }, [responseReceived, isKeyDialog]);

  return (
    <>
      {responseReceived ? (
        <div className="Apikey">
          <p className="Apikey__title">API Key</p>
          {store?.currentProvider?.cachedAdapter !== "openlogin" && (
            <div className="Apikey__inputContainer">
              <input
                type="text"
                className="outlineInput"
                placeholder="Insert name to generate your key"
                ref={inputRef}
                onChange={() => {
                  setGenerateDisabled(
                    inputRef?.current?.value?.length === 0 ? true : false
                  );
                }}
              />
              <button
                className="outlineBtn"
                disabled={isGenerateDisabled}
                onClick={() => {
                  setKeyDialog(true);
                }}
              >
                Generate
              </button>
            </div>
          )}

          <div className="Apikey__tableContainer">
            <table>
              <thead>
                <tr className="tableHead">
                  <th>Key Name</th>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                      <th>Key Prefix</th>
                      <th>Key Scope</th>
                    </>
                  )}

                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.map((item: any, index) => (
                  <tr className="ptr" key={index}>
                    <td>
                      <p>{item?.keyName}</p>
                    </td>
                    {isMobile ? (
                      <></>
                    ) : (
                      <>
                        <td>
                          <p>{item?.keyPrefix || "-"}</p>
                        </td>
                        <td>
                          <p>{item?.scope}</p>
                        </td>
                      </>
                    )}

                    <td>
                      <span
                        className="icon"
                        onClick={async () => {
                          setResponseReceived(false);
                          await deleteAPIKey(item?.id);
                          setResponseReceived(true);
                        }}
                      >
                        <AiOutlineDelete />
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="Apikey__lowerContainer">
            <Pagination
              orignalData={APIKeys}
              setCurrentData={setCurrentItems}
              itemsPerPage={itemsPerPage}
              type={""}
            />
          </div>
        </div>
      ) : (
        <div className="loadingContainer">
          <ReactLoading
            type={"bubbles"}
            color={"#4452FE"}
            height={667}
            width={375}
          />
        </div>
      )}
      <Dialog
        open={isKeyDialog}
        onClose={() => {
          setKeyDialog(false);
        }}
        classes={{
          paper: "ApikeyDialogRoot",
        }}
      >
        <ApikeyDialog
          setKeyDialog={setKeyDialog}
          keyName={inputRef?.current?.value || ""}
        />
      </Dialog>
    </>
  );
}

export default Apikey;
